export const DESCRIPTION = 'Official app - free';
export const CTA_BUTTON_TEXT = 'Get the app';
export const CTA_LINK_HOMEAWAY = 'https://t.hmwy.io/6WIuXZNLf6';
export const CTA_LINK_VRBO = 'https://t.vrbo.io/9t5qCBXLf6';
export const HOMEAWAY = 'HomeAway';
export const RATING = '709.7K';
export const RATING_TEXT = 'Ratings';
export const STARS = 4.8;
export const TITLE = 'Get Vrbo on the go!';
export const VRBO = 'Vrbo';
export const HOMEAWAY_SITE = 'homeaway_us';
export const MODAL_CLOSE_BUTTON_TEXT = 'Not Yet';
export const BRANCH_KEY = 'key_live_nirBKlMulpVhZT1Rue3YsebcAAlgafLk';
export const BRANCH_SRC = 'https://cdn.branch.io/branch-latest.min.js';
export const STAYZ = 'Stayz';
export const BOOKABACH = 'Bookabach';
export const ABRITEL = 'Abritel';
export const FEWO = 'FeWo-direkt';
export const BANNER = 'banner';
export const MODAL = 'modal';
export const BUTTON = 'button';
export const LINK = 'link';
export const CTA = 'CTA';
